// Un daño queda en revisión (REVIEWING) cuando ya tiene evidencias y el socio lo cierra (solo lectura).
// Sin todos los daños en revisión no se puede enviar la solicitud completa.
export function areAllDetailsFinalized(details: any[] | null | undefined): boolean {
  if (!details?.length) return false;
  return details.every(d => d.statusSlug === 'REVIEWING');
}

export function labelForClaimType(slug: string | null | undefined): string {
  if (slug === 'TOTAL_LOSS') return 'Pérdida Total';
  if (slug === 'ACCIDENT_THIRD_PARTY') return 'Accidente con Terceros';
  if (slug === 'ACCIDENT') return 'Accidente Simple';
  return slug ?? '';
}

export function countPendingDetails(details: any[] | null | undefined): number {
  if (!details?.length) return 0;
  return details.filter(d => d.statusSlug !== 'REVIEWING').length;
}

/** Progreso de evidencias de un daño respecto a los document_claim del siniestro. */
export function getDetailEvidenceProgress(
  detail: any,
  claimDocuments: any[] | null | undefined
): { label: string; badgeClass: string; uploaded: number; total: number } {
  const docs = (claimDocuments ?? []).filter((d: any) => {
    const docDetailId = d.claimDetailId ?? d.claim_detail_id;
    const matchId = docDetailId && detail.id && docDetailId == detail.id;
    const matchUuid = d.claimDetail?.uuid && detail.uuid && d.claimDetail.uuid === detail.uuid;
    return matchId || matchUuid;
  });
  const observed = docs.filter((d: any) => {
    const slug = String(d.statusSlug || '').toUpperCase();
    if (slug === 'OBSERVED') return true;
    return slug === 'PENDING' && !!String(d.reviewComment || '').trim();
  }).length;
  if (observed > 0) {
    return { label: 'Corrección pendiente', badgeClass: 'border-warning text-warning', uploaded: 0, total: observed };
  }
  if (detail?.statusSlug === 'APPROVED') {
    return { label: 'Aprobado', badgeClass: 'border-success text-success', uploaded: 0, total: 0 };
  }
  if (detail?.statusSlug === 'REJECTED') {
    return { label: 'Rechazado', badgeClass: 'border-danger text-danger', uploaded: 0, total: 0 };
  }
  if (detail?.statusSlug === 'REVIEWING') {
    return { label: 'En revisión', badgeClass: 'border-info text-info', uploaded: 0, total: 0 };
  }
  if (!detail?.id && !detail?.uuid) {
    return { label: 'Borrador', badgeClass: 'border-secondary text-muted', uploaded: 0, total: 0 };
  }

  if (!docs.length) {
    return { label: 'Sin evidencias', badgeClass: 'border-warning text-warning', uploaded: 0, total: 0 };
  }

  const uploaded = docs.filter((d: any) => !!(d.document?.uuid || d.filePath || d.document?.filePath)).length;
  const total = docs.length;
  if (uploaded < total) {
    return {
      label: `Evidencias ${uploaded}/${total}`,
      badgeClass: 'border-warning text-warning',
      uploaded,
      total
    };
  }
  return {
    label: 'Listo para revisión',
    badgeClass: 'border-primary text-primary',
    uploaded,
    total
  };
}

/** Quita puntos de miles y deja un número listo para la API. */
export function sanitizeNumericValue(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const clean = String(value).replace(/\./g, '').replace(',', '.').trim();
  const n = Number(clean);
  return Number.isFinite(n) ? n : 0;
}

export function formatDisplayNumber(value: unknown): string {
  const n = sanitizeNumericValue(value);
  return n.toLocaleString('de-DE');
}

